// extracted by mini-css-extract-plugin
export default {"input":"S0lpGu","wrapper":"zvl4Oy"};